<loren-error-template
  [title]="'error_page.not_found_title' | transloco"
  [message]="'error_page.not_found_message' | transloco"></loren-error-template>
